// VSB countdown (sections/vsb-countdown): the store's shared timer, as the
// store's lp-hero-timer-stored and vsb-announcement-bar run it. Every timer
// section reads and writes the same key, so they all count down to the same
// moment, and a run-out timer starts again from the section's length.
if (!customElements.get('vsb-countdown')) {
  const TIMER_KEY = 'exclusiveWelcome_shared_timer'; // shared with every timer section: do not rename
  const pad = (n) => String(n).padStart(2, '0');

  customElements.define(
    'vsb-countdown',
    class VsbCountdown extends HTMLElement {
      connectedCallback() {
        this.seconds = Number(this.dataset.seconds) || 900;
        this.parts = {
          h: this.querySelector('[data-countdown-hours]'),
          m: this.querySelector('[data-countdown-minutes]'),
          s: this.querySelector('[data-countdown-seconds]'),
        };
        if (!this.parts.h || !this.parts.m || !this.parts.s) return;
        this.tick();
        this.id_ = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.id_);
      }

      expiry() {
        let expiry = NaN;
        try {
          expiry = parseInt(localStorage.getItem(TIMER_KEY), 10);
        } catch (e) {
          expiry = this.memoryExpiry;
        }
        if (Number.isNaN(expiry) || !expiry || expiry <= Date.now()) {
          expiry = Date.now() + this.seconds * 1000;
          this.memoryExpiry = expiry;
          try {
            localStorage.setItem(TIMER_KEY, expiry);
          } catch (e) {
            /* storage blocked: this page keeps its own count */
          }
        }
        return expiry;
      }

      tick() {
        const s = Math.max(0, Math.floor((this.expiry() - Date.now()) / 1000));
        const set = (el, v) => { if (el.textContent !== v) el.textContent = v; };
        set(this.parts.h, pad(Math.floor(s / 3600)));
        set(this.parts.m, pad(Math.floor((s % 3600) / 60)));
        set(this.parts.s, pad(s % 60));
      }
    }
  );
}
